import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, Sparkles } from "lucide-react";
import api from "../lib/api";
import { useCart } from "../context/CartContext";

/**
 * Live Shopping rail — pinned products during a live stream.
 * Shown on the live Watch page so fans can buy instantly without leaving the feed.
 */
export default function LiveShopRail({ streamId }) {
  const [products, setProducts] = useState([]);
  const { add } = useCart();

  useEffect(() => {
    if (!streamId) return;
    api.get(`/live/${streamId}/products`).then((r) => setProducts(r.data || [])).catch(() => {});
  }, [streamId]);

  if (!products.length) return null;

  return (
    <section data-testid="live-shop-rail" className="mt-6">
      <div className="flex items-center justify-between mb-2">
        <div className="text-[10px] uppercase tracking-[0.3em] text-tv-accent font-bold flex items-center gap-2">
          <Sparkles className="w-3 h-3" /> Shop this stream
        </div>
        <Link to="/cart" className="text-xs text-white/60 hover:text-white">Cart →</Link>
      </div>
      <div className="flex gap-3 overflow-x-auto tv-scroll-x pb-2">
        {products.map((p) => (
          <div key={p.id} data-testid={`live-shop-item-${p.id}`} className="shrink-0 w-[160px] tv-glass rounded-xl overflow-hidden border border-white/5 hover:border-tv-accent/40 transition">
            <Link to={`/shop/product/${p.id}`} className="block aspect-square bg-black">
              <img src={(p.images || [])[0] || "https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=300&q=80"} alt="" className="w-full h-full object-cover" />
            </Link>
            <div className="p-2">
              <div className="text-white text-xs font-semibold line-clamp-1">{p.title}</div>
              <div className="flex items-center justify-between mt-1.5">
                <span className="text-tv-accent font-black text-sm">${p.price_usd.toFixed(2)}</span>
                <button data-testid={`live-shop-add-${p.id}`} onClick={() => add(p.id, 1)} className="bg-tv-accent text-black font-bold text-[10px] px-2 py-1 rounded-full flex items-center gap-1">
                  <ShoppingBag className="w-3 h-3" /> Add
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
